import type { FaireProductEntity } from "../../entity_types/product";

export const p_spmhg6r6h6: FaireProductEntity = {
  token: "p_spmhg6r6h6",
  type: "product",
  name: "Gold Bow Beaded Statement Christmas Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/69a2fe3f932bf6c46b0efeed9e2e801364e5f8edf588137927f2ccab05cbf972.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8c54f651f6f00bba1a0d0e05fcf7db408fb580002f1c2cd79fb4eb952bc788f.jpeg",
    "https://cdn.faire.com/fastly/c6a7fb17e78f1a678aa97a4f529c070bb3e1de1ea498d82d607cf37a260b7273.jpeg",
    "https://cdn.faire.com/fastly/b26019a265c98f742c7c34233dafce06560c1cb446fb51c16b04eaa05a03af30.jpeg",
    "https://cdn.faire.com/fastly/1f627bf75037a501b3215b65b2a45bcbb1c7658a034d8ab09516aab9b24e4ac6.jpeg",
    "https://cdn.faire.com/fastly/bf4df2dd75464a1beb29de9dead40a2a05d1ac97800532aabe631e3584888611.jpeg",
    "https://cdn.faire.com/fastly/ce86c14b43dcf4f8be52c9bab2a840b09b2a5e8ef6a09ab4da9af68572404ad1.jpeg"
  ],
  priceDollars: 14,
  description: "Gold Christmas Bow Beaded Statement Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings\n\nGold Christmas Bow Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings - Fashion Earrings for Her\n\nThese lightweight earrings that you will practically forget you are wearing them.\n\nSize is 2.4 x 2.25 inches.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:06.803Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
